import {
	API_ERROR,
	INPUT_CHANGEVALUE,
	SELECT_CHANGEVALUE,
	MR_INPUT_CHANGEVALUE,
	MR_SELECT_CHANGEVALUE,
	SI_INPUT_CHANGEVALUE,
	ITEM_QTY_CHANGEVALUE,
	ITEM_UNITES_CHANGEVALUE,
	SI_SELECT_CHANGEVALUE,
	MY_MATERIALREQUEST_LIST,
	MATERIALREQUEST_LIST,
	DEPT_MATERIALREQUEST_LIST,
	ALL_MATERIALREQUEST_LIST,
	MATERIALREQUEST_LIST_SUCCESS,
	MATERIALREQUEST_LIST_COUNT,
	MY_MATERIALREQUEST_LIST_COUNT,
	DEPT_MATERIALREQUEST_LIST_COUNT,
	ALL_MATERIALREQUEST_LIST_COUNT,
	MATERIALREQUEST_LIST_COUNT_SUCCESS,
	PRODUCTS_ROW_REQUEST,
	PRODUCTS_ROW_REQUEST_SUCCESS,
	SELECTED_PRODUCTS_LIST,
	REMOVE_SELECTED_PRODUCT,
	MODEL_OPEN,
	MODEL_CLOSE,
	GET_USER_DEPARTMENT,
	USER_DEPARTMENT_SUCCESS,
	MATERIALREQUEST_ROW_DATA,
	MATERIALREQUEST_ROW_DATA_SUCCESS,
	TOGGLE_ITEM_MENU,
	MATERIALREQUEST_DELETE,
	ITEM_HOD_APPROVAL,
	MR_ITEM_HOD_APPROVAL,
	MRI_STORE_USER_APPROVAL,
	MRI_STORE_HOD_APPROVAL,
	MT_ROW_LOADING,
	C_PRODUCT_IMAGE,
	C_PRODUCT_CHANGEVALUE,
	C_PRODUCT_SELECT_CHANGEVALUE,
	CUSTOM_PRODUCT_ADD,
	CUSTOMPRODUCT_ADD_SUCCESS,
	CHANGE_TOGGALE_TAB,
	SET_PARAMS,
	FILTER_INPUT_CHANGEVALUE,
	FILTER_SELECT_CHANGEVALUE,
	LIST_LAYOUT,
	PRODUCTS_REQUEST_LIST,
	PRODUCTS_REQUEST_LIST_SUCCESS,
	MODEL_LIST_OPEN,
	MODEL_LIST_CLOSE,
	MATERIALREQUEST_ADD,
	MR_DEPT_HOD_APPROVE_ADD,
	ALL_MR_HOD_ITEM_LIST_CHECKED,
	MR_HOD_ITEM_LIST_CHECKED,
	MR_HOD_APPROVE_ADD,
	MATERIALREQUEST_ADD_SUCCESS,
	CHANGE_ITEM_MODEL_OPEN,
	CHANGE_ITEM_MODEL_CLOSE,
	C_PRODUCT_RIGHT_SIDEBAR,
	C_PRODUCT_HIDE_RIGHT_SIDEBAR,
	CHANGE_ACTIVATE_PRODUCT,
	FILTERS_SHOW_RIGHT_SIDEBAR,
	FILTERS_HIDE_RIGHT_SIDEBAR,
	CLEAR_FILTER,
	VIEW_LOG_SHOW_RIGHT_SIDEBAR,
	VIEW_LOG_HIDE_RIGHT_SIDEBAR,
	ITEM_TIME_LINE,
	ITEM_TIME_LINE_SUCCESSFUL,
	PI_ITEM_TIME_LINE,
	PO_ITEM_TIME_LINE,
	IGP_ITEM_TIME_LINE,
	PRODUCT_STORE_QTY,
	PRODUCT_STORE_QTY_SUCCESSFUL,
	PDF_DOWNNLOAD,
	CLEAR_DATA,
	PRODUCT_HISTORY,
	PRODUCT_HISTORY_SUCCESSFUL,
	PRODUCT_HISTORY_MODEL_CLOSE,
	PRODUCT_ITEM_HISTORY_MODEL_OPEN,
	PRODUCT_ITEM_HISTORY_MODEL_CLOSE,
	MR_ITEM_IMAGES_UPLOAD,
	MR_ITEM_UPDATE_IMAGE,
	MATERIAL_REQUEST_CLOSE,
	MRQ_FOCUS_POST,
	PRODUCT_QUALITIES_SELECT_CHANGEVALUE,
} from "./actionTypes";
import moment from "moment";

const initialState = {
	loading: false,
	activeTab: 1,
	error_msg: {},
	productslist: [],
	productsCount: 0,
	listModel: false,
	actionMenu: false,
	selectedItems: [],
	rowdata: {},
	mrRowData: {},
	UserDepts: [],
	mrCustomItem: [],
	MRcheckedItem: [],
	mrPedningItems: [],
	mrItemsList: [],
	mrRowlistcount: 0,
	mrListCount: 0,
	productRowdata: {},
	cPRowData: {},
	filterdata: {},
	Sortvar: {
		id: "REQUEST NO",
		createdon: "CREATED ON",
	},
	dataLoading: false,
	params: {
		mrstatus: [0],
		pistatus: [0],
		mistatus: [0],
		no_of_pages: 0,
		page_size: 20,
		page: 1,
		search: "",
		currentSort: "id",
		sortOrder: "-",
	},
	layout: "list",
	Change_item_model: false,
	changeItem: {},
	changeCustomeItem: {},
	showCPRightSidebar: false,
	MRlevel: "DeptHOD",
	activateproduct: false,
	MRFilterlevel: null,
	showFilterRightSidebar: false,
	showViewLogRightSidebar: false,
	itemTimeLine: [],
	mrIssueItem: [],
	itemSelectedId: 0,
	selectedPIItemId: 0,
	selectedCQItemId: 0,
	selectedIGPItemId: 0,
	PITimeLineItems: [],
	TimeLineProduct: {},
	PIitemTimeLine: [],
	RFQItemsTimeLine: [],
	CQTimeLineItems: [],
	POItemsTimeLine: [],
	IGPItemsTimeLine: [],
	IGPTimeLine: [],
	productStoreQty: {},
	cPimage: {},
	productHistorylist: [],
	productHistory_model: false,
	PIData: {},
	productItemLoglist: [],
	productItemHistory_model: false,
	MRItemImage: [],
};

const materialrequest = (state = initialState, action) => {
	switch (action.type) {
		case CLEAR_DATA:
			state = {
				...state,
				mrRowData: {},
				selectedItems: [],
			};
			break;
		case INPUT_CHANGEVALUE:
			state = {
				...state,
				rowdata: {
					...state.rowdata,
					[action.payload.key]: action.payload.value,
				},
			};
			break;
		case SELECT_CHANGEVALUE:
			state = {
				...state,
				rowdata: {
					...state.rowdata,
					[action.payload.key]: action.payload.label,
					[action.payload.key2]: action.payload.value,
				},
			};
			break;

		case MR_INPUT_CHANGEVALUE:
			state = {
				...state,
				mrRowData: {
					...state.mrRowData,
					[action.payload.key]: action.payload.value,
				},
			};
			break;
		case MR_SELECT_CHANGEVALUE:
			state = {
				...state,
				mrRowData: {
					...state.mrRowData,
					[action.payload.key]: action.payload.label,
					[action.payload.key2]: action.payload.value,
				},
			};
			break;
		case SI_INPUT_CHANGEVALUE:
			var selectedItems = state.selectedItems.map((p) => {
				if (p.product?.id === action.payload.item.product.id) {
					p.qty = action.payload.value;
				}
				return p;
			});
			state = {
				...state,
				selectedItems: selectedItems,
			};
			break;

		case SI_SELECT_CHANGEVALUE:
			var selectedItems1 = state.selectedItems.map((p) => {
				if (p.product?.id === action.payload.item.product.id) {
					p.unit = {
						id: action.payload.value,
						name: action.payload.label,
					};
				}
				return p;
			});

			state = {
				...state,
				selectedItems: selectedItems1,
			};
			break;

		case PRODUCTS_REQUEST_LIST:
			if (action.payload.clearList === true) {
				state.productslist = [];
			}
			state = {
				...state,
				dataLoading: true,
				loading: true,

				rowdata: {},
			};
			break;
		case PRODUCTS_REQUEST_LIST_SUCCESS:
			var selectedItems_ids = [];
			var productslist = [];
			var noofpages = Math.ceil(
				action.payload.count / state.params.page_size
			);
			if (!state.Change_item_model) {
				selectedItems_ids = state.selectedItems.map((p) => {
					return p.product.id;
				});
			} else {
				selectedItems_ids = state.mrItemsList.map((p) => {
					return p.product.id;
				});
			}
			productslist = action.payload.results.filter((p) => {
				return selectedItems_ids.indexOf(p.id) === -1;
			});

			state = {
				...state,
				productslist: [...state.productslist, ...productslist],
				productsCount: action.payload.count,
				// ChangeProductList:
				dataLoading: false,
				params: {
					...state.params,
					no_of_pages: noofpages,
				},
				loading: false,
				// model: true,
			};
			break;
		case PRODUCTS_ROW_REQUEST:
			state = {
				...state,
				loading: true,
			};
			break;

		case PRODUCTS_ROW_REQUEST_SUCCESS:
			state = {
				...state,
				productRowlist: action.payload.response,
				loading: false,
				rowdata: {},
				// model: true,
			};
			break;
		case PRODUCT_QUALITIES_SELECT_CHANGEVALUE:
			state = {
				...state,
				rowdata: {
					...state.rowdata,
					[action.payload.key]: action.payload.label,
					[action.payload.key2]: action.payload.value,
				},
			};
			break;
		case SELECTED_PRODUCTS_LIST:
			var productslists = state.productslist.filter((p) => {
				return p.id !== action.payload.product_id;
			});

			var item = action.payload;
			// console.log(item, "LLLLLLLLLLLLLLLLLLitem");
			// console.log(state.selectedItems, "LLLLLLLLLLLLLLLLLLitem");

			state = {
				...state,

				rowdata: {
					date: moment().format("DD-MM-YYYY"),
				},
				productslist: productslists,
				selectedItems: [
					...state.selectedItems,
					{
						qty: item.qty,
						unit_id: item.unit_id,
						// unitsLabel: item.unitsLabel,
						date: moment(item.date).format("DD-MM-YYYY"), //item.date,
						make: item.make,
						description: item.description,
						product_id: item.product_id,
						department: {
							id: item.department.id,
							name: item.department.name,
						},
						qualities:
							item.quality_ids &&
							Array.isArray(item.quality_ids) &&
							item.quality_ids.length > 0
								? item.quality_ids.map((qualityId, index) => ({
										id: qualityId,
										name: Array.isArray(item.qualityLabel)
											? item.qualityLabel[index]
											: item.qualityLabel,
								  }))
								: [],
						unit: {
							id: item.unit_id,
							name: item.unitsLabel,
						},
						item_info: item.item_info,
						product: {
							id: item.product_id,
							image: item.image,
							name: item.name,
						},
					},
				],
			};
			break;
		case REMOVE_SELECTED_PRODUCT:
			var selectedItems2 = [];
			if (action.payload.id) {
				selectedItems2 = state.selectedItems.map((item) => {
					if (item.product?.id === action.payload.product.id)
						item.dodelete = true;
					return item;
				});
			} else {
				selectedItems2 = state.selectedItems.filter(
					(p) => p.product?.id !== action.payload.product.id
				);
			}
			state = {
				...state,
				selectedItems: selectedItems2,
			};
			break;
		case MATERIALREQUEST_ADD:
			state = {
				...state,
				loading: true,
			};
			break;
		case MATERIALREQUEST_ADD_SUCCESS:
			state = {
				...state,
				message: action.payload,

				loading: false,
			};
			break;
		case SET_PARAMS:
			state = {
				...state,
				params: action.payload,
			};
			break;
		case FILTER_INPUT_CHANGEVALUE:
			state = {
				...state,
				params: {
					...state.params,
					[action.payload.key]: action.payload.value,
				},
			};
			break;
		case FILTER_SELECT_CHANGEVALUE:
			state = {
				...state,
				filterdata: {
					...state.filterdata,
					[action.payload.key]: action.payload.label,
				},
				params: {
					...state.params,
					[action.payload.key2]: action.payload.value,
				},
			};
			break;
		case MATERIALREQUEST_LIST_COUNT:
			state = {
				...state,
				loading: true,
			};
			break;
		case MY_MATERIALREQUEST_LIST_COUNT:
			state = {
				...state,
				loading: true,
			};
			break;
		case DEPT_MATERIALREQUEST_LIST_COUNT:
			state = {
				...state,
				loading: true,
			};
			break;
		case ALL_MATERIALREQUEST_LIST_COUNT:
			state = {
				...state,
				loading: true,
			};
			break;
		case MATERIALREQUEST_LIST_COUNT_SUCCESS:
			state = {
				...state,
				mrListCount: action.payload,
				loading: false,
			};

			break;
		case MY_MATERIALREQUEST_LIST:
			state = {
				...state,
				loading: true,
			};
			break;
		case MATERIALREQUEST_LIST:
			state = {
				...state,
				loading: true,
			};
			break;
		case DEPT_MATERIALREQUEST_LIST:
			state = {
				...state,
				loading: true,
			};
			break;
		case ALL_MATERIALREQUEST_LIST:
			state = {
				...state,
				loading: true,
			};
			break;
		case MATERIALREQUEST_LIST_SUCCESS:
			var noofpages1 = Math.ceil(
				action.payload.count / state.params.page_size
			);

			state = {
				...state,
				mrRowList: action.payload.results,
				mrRowlistcount: action.payload.count,
				params: {
					...state.params,
					no_of_pages: noofpages1,
				},
				loading: false,
			};

			break;
		case GET_USER_DEPARTMENT:
			state = {
				...state,
				// UserDepts: action.payload.UserDepts,
				loading: true,
			};
			break;
		case USER_DEPARTMENT_SUCCESS:
			state = {
				...state,
				UserDepts: action.payload,
				loading: false,
			};
			break;
		case ITEM_QTY_CHANGEVALUE:
			var QtyChangeItem = [];
			if (action.payload.status === "DeptHod") {
				QtyChangeItem = state.mrItemsList.map((p) => {
					if (p.product?.id === action.payload.item.product.id) {
						p.t_qty = action.payload.value;
					}
					return p;
				});
				state = {
					...state,
					mrItemsList: QtyChangeItem,
				};
			}
			if (action.payload.status === "MaterialHod") {
				QtyChangeItem = state.mrCustomItem.map((p) => {
					if (p.product?.id === action.payload.item.product.id) {
						p.t_qty = action.payload.value;
					}
					return p;
				});
				state = {
					...state,
					mrCustomItem: QtyChangeItem,
				};
			}

			break;

		case ITEM_UNITES_CHANGEVALUE:
			var UniteChangeItems = [];
			if (action.payload.status === "DeptHod") {
				UniteChangeItems = state.mrItemsList.map((p) => {
					if (p.product?.id === action.payload.item.product.id) {
						p.t_unit = {
							id: action.payload.value,
							name: action.payload.label,
						};
					}
					return p;
				});

				state = {
					...state,
					mrItemsList: UniteChangeItems,
				};
			}
			if (action.payload.status === "MaterialHod") {
				UniteChangeItems = state.mrCustomItem.map((p) => {
					if (p.product?.id === action.payload.item.product.id) {
						p.t_unit = {
							id: action.payload.value,
							name: action.payload.label,
						};
					}
					return p;
				});

				state = {
					...state,
					mrCustomItem: UniteChangeItems,
				};
			}
			break;
		case MATERIALREQUEST_ROW_DATA:
			state = {
				...state,
				loading: true,
				Change_item_model: false,
			};
			break;
		case MATERIALREQUEST_ROW_DATA_SUCCESS:
			var UserDeptIds = state.UserDepts.map((dept) => dept.id);
			var customItems = action.payload.response.mritems.filter((item) => {
				if (UserDeptIds.indexOf(item.department.id) === -1) {
					return false;
				}
				item.itemcheck = false;
				return true;
			});

			//  customItems.filter((item) => {
			//   if (item.mrstatus === 5) {
			//     return true;
			//   }
			//   return 0;
			// });

			// var mrPedningItems = [];
			state.mrPedningItems = customItems.filter((item) => {
				return item.mrstatus === 3;
			});
			// if (mrPedningItems.length != 0) {
			//   state.MRButtons = true;
			// }
			var mr_approvals = [];
			mr_approvals = action.payload.response.mr_approvals.filter(
				(approvale) => {
					if (approvale.mrstatus === 3) {
						return approvale.approvedby;
					}
					return 0;
				}
			);
			state = {
				...state,
				mrRowData: {
					...action.payload.response,
					userDeptApprovedby: mr_approvals,
				},
				mrCustomItem: customItems,
				mrItemsList: action.payload.response.mritems,
				selectedItems: action.payload.response.mritems,
				loading: false,
			};
			break;
		case ALL_MR_HOD_ITEM_LIST_CHECKED:
			var MRlistItems = [];
			if (action.payload.checked === true) {
				MRlistItems = state.mrCustomItem.map((item) => {
					if (item.mrstatus === 3 && item.product.active === true) {
						item.itemcheck = true;
					}
					return item;
				});

				state.MRcheckedItem = MRlistItems.filter((item) => {
					return item.itemcheck;
				});
				state.allItemsCheked = true;
			} else {
				MRlistItems = state.mrCustomItem.map((item) => {
					item.itemcheck = false;
					return item;
				});
				state.MRcheckedItem = [];
				state.allItemsCheked = false;
			}
			state = {
				...state,

				mrCustomItem: MRlistItems,
			};
			break;
		case MR_HOD_ITEM_LIST_CHECKED:
			if (action.payload.checked === true) {
				state.mrCustomItem[action.payload.index].itemcheck = true;
				state = {
					...state,
					MRcheckedItem: [
						...state.MRcheckedItem,
						{ ...action.payload.item },
					],

					loading: false,
				};
			} else {
				state.mrCustomItem[action.payload.index].itemcheck = false;
				var mRcheckedItem = state.MRcheckedItem.filter((p) => {
					return p.id !== action.payload.item.id;
				});

				state = {
					...state,

					MRcheckedItem: mRcheckedItem,
				};
			}

			if (state.mrCustomItem.length === state.MRcheckedItem.length) {
				state.allItemsCheked = true;
			} else {
				state.allItemsCheked = false;
			}

			break;
		case MODEL_OPEN:
			state = {
				...state,
				loading: true,
				model: true,
				productslist: [],
			};
			break;
		case MODEL_CLOSE:
			state = {
				...state,
				model: false,
				params: { ...state.params, search: "", page: 1 },
				productslist: [],
				cPRowData: {},
			};
			break;

		case MODEL_LIST_OPEN:
			state = {
				...state,
				mrItemsList: state.mrItemsList,
				loading: true,
				listModel: true,
			};
			break;
		case MODEL_LIST_CLOSE:
			state = {
				...state,
				listModel: false,
			};
			break;
		case TOGGLE_ITEM_MENU:
			var mrRowList = state.mrRowList?.map((i) => {
				if (i.id === action.payload) {
					i.actionMenu = !i.actionMenu;
				} else {
					i.actionMenu = false;
				}
				return i;
			});

			state = {
				...state,
				mrRowList: mrRowList,
			};
			break;

		case MATERIALREQUEST_DELETE:
			state = {
				...state,
				loading: false,
			};
			break;
		case ITEM_HOD_APPROVAL:
			state = {
				...state,
				loading: true,
			};
			break;
		case MR_DEPT_HOD_APPROVE_ADD:
			state = {
				...state,
				loading: true,
			};
			break;

		case MR_ITEM_HOD_APPROVAL:
			state = {
				...state,
				loading: true,
			};
			break;
		case MRI_STORE_USER_APPROVAL:
			state = {
				...state,
				loading: true,
			};
			break;
		case MRI_STORE_HOD_APPROVAL:
			state = {
				...state,
				loading: true,
			};
			break;
		case MR_HOD_APPROVE_ADD:
			state = {
				...state,
				loading: true,
			};
			break;

		case MT_ROW_LOADING:
			state = {
				...state,
				// loading: true,
				Change_item_model: false,
				mrRowData: {
					...state.mrRowData,
					loading: action.payload,
				},
			};
			break;
		case C_PRODUCT_IMAGE:
			state = {
				...state,
				cPimage: action.payload.file,
				imagePreviewUrl: action.payload.imagePreviewUrl,
			};
			break;
		case C_PRODUCT_CHANGEVALUE:
			state = {
				...state,
				cPRowData: {
					...state.cPRowData,
					[action.payload.key]: action.payload.value,
					deparment_id: state.rowdata.deparment_id,
				},
			};

			break;
		case C_PRODUCT_SELECT_CHANGEVALUE:
			state = {
				...state,
				cPRowData: {
					...state.cPRowData,
					[action.payload.key]: action.payload.label,
					[action.payload.key2]: action.payload.value,
				},
			};
			break;

		case CUSTOM_PRODUCT_ADD:
			state = {
				...state,
				error_msg: {},
				loading: true,
			};
			break;
		case CUSTOMPRODUCT_ADD_SUCCESS:
			if (!state.Change_item_model) {
				state = {
					...state,
					loading: false,
					selectedItems: [
						...state.selectedItems,
						{
							description: state.cPRowData.cdescription,
							date:
								state.cPRowData.cdate == null
									? moment(new Date()).format("DD-MM-YYYY")
									: moment(state.cPRowData.cdate).format(
											"DD-MM-YYYY"
									  ),
							make: state.cPRowData.cmake,
							qty: state.cPRowData.citem_qty,
							unit: action.payload.response.data.units[0],
							product: action.payload.response.data,
							product_id: action.payload.response.data.id,
							department: {
								id: action.payload.response.data.department.id,
								name: action.payload.response.data.department
									.name,
							},
							qualities:
								action.payload.response.data.quality_ids &&
								Array.isArray(
									action.payload.response.data.quality_ids
								) &&
								action.payload.response.data.quality_ids
									.length > 0
									? action.payload.response.data.quality_ids.map(
											(qualityId, index) => ({
												id: qualityId,
												name: Array.isArray(
													action.payload.response.data
														.qualityLabel
												)
													? action.payload.response
															.data.qualityLabel[
															index
													  ]
													: action.payload.response
															.data.qualityLabel,
											})
									  )
									: [],
						},
					],
				};
			} else {
				state.changeCustomeItem = action.payload.response;
			}
			break;
		case CHANGE_TOGGALE_TAB:
			state = {
				...state,

				activeTab: action.payload.tab,
				imagePreviewUrl: "",
				cPRowData: {},
				cPimage: {},
				loading: false,
			};
			break;
		case LIST_LAYOUT:
			state = {
				...state,
				layout: action.payload,
				loading: false,
			};
			break;
		case CHANGE_ITEM_MODEL_OPEN:
			state = {
				...state,
				Change_item_model: true,
				changeItem: action.payload.item,
				PIData: action.payload.PIData ? action.payload.PIData : {},

				MRlevel: action.payload.MRlevel,

				loading: false,
			};
			break;
		case CHANGE_ITEM_MODEL_CLOSE:
			state = {
				...state,
				Change_item_model: false,

				params: { ...state.params, search: "", page: 1 },
				// productslist: [],
				// cPRowData: {},
				loading: false,
			};
			break;
		case CHANGE_ACTIVATE_PRODUCT:
			state = {
				...state,
				productRowlist: action.payload,
				Change_item_model: true,
				activeTab: 2,
				activateproduct: true,
				MRlevel: "MRHod",
			};
			break;
		case C_PRODUCT_RIGHT_SIDEBAR:
			state = {
				...state,
				Change_item_model: false,
				changeItem: action.payload.item,
				showCPRightSidebar: !state.showCPRightSidebar,
			};
			break;
		case C_PRODUCT_HIDE_RIGHT_SIDEBAR:
			state = {
				...state,
				showRightSidebar: false,
			};
			break;
		case FILTERS_SHOW_RIGHT_SIDEBAR:
			state = {
				...state,
				MRFilterlevel: action.payload.MRFilterlevel,
				showFilterRightSidebar: !state.showFilterRightSidebar,
			};
			break;
		case FILTERS_HIDE_RIGHT_SIDEBAR:
			state = {
				...state,
				MRFilterlevel: null,
				showFilterRightSidebar: false,
			};
			break;
		case CLEAR_FILTER:
			state = {
				...state,
				filterdata: {},
			};
			break;
		case VIEW_LOG_SHOW_RIGHT_SIDEBAR:
			state = {
				...state,

				showViewLogRightSidebar: !state.showViewLogRightSidebar,
			};
			break;
		case VIEW_LOG_HIDE_RIGHT_SIDEBAR:
			state = {
				...state,
				itemTimeLine: [],
				mrIssueItem: [],
				PIitemTimeLine: [],
				RFQItemsTimeLine: [],
				POItemsTimeLine: [],
				IGPItemsTimeLine: [],
				IGPTimeLine: [],
				selectedPIItemId: 0,
				selectedCQItemId: 0,
				selectedIGPItemId: 0,
				showViewLogRightSidebar: false,
			};
			break;
		case ITEM_TIME_LINE:
			state = {
				...state,
				itemTimeLine: [],
				mrIssueItem: [],
				PIitemTimeLine: [],
				RFQItemsTimeLine: [],
				POItemsTimeLine: [],
				IGPItemsTimeLine: [],
				IGPTimeLine: [],
				selectedPIItemId: 0,
				selectedCQItemId: 0,
				selectedIGPItemId: 0,
				itemSelectedId: action.payload.MRItemId,
				loading: true,
			};
			break;
		case ITEM_TIME_LINE_SUCCESSFUL:
			var mrItemCreate = {
				type: "MRCreate",
				createdon: action.payload.createdon,
				product:
					action.payload.mri_approvals.length === 0
						? action.payload.product
						: action.payload.mri_approvals[0].f_product,
				qty:
					action.payload.mri_approvals.length === 0
						? action.payload.qty
						: action.payload.mri_approvals[0].f_qty,
				unit:
					action.payload.mri_approvals.length === 0
						? action.payload.unit
						: action.payload.mri_approvals[0].f_unit,
			};

			var MRitemTimeLine = action.payload.mri_approvals.map((item) => {
				item.type = "MRlevel";
				return item;
			});
			var mrIssueItemCreate = {};
			// console.log("action payload mr", action.payload);
			if (action.payload.miitems.length > 0) {
				mrIssueItemCreate = {
					type: "MRIssueCreate",
					mrissueCode: action.payload.miitems[0].materialissue.code,
					createdby:
						action.payload.miitems[0].materialissue.createdby,
					createdon:
						action.payload.miitems[0].materialissue.createdon,
					location: action.payload.miitems[0].materialissue.location,
					product: action.payload.miitems[0].product,
					qty: action.payload.miitems[0].qty,
					unit: action.payload.miitems[0].unit,
				};
			}
			var PIItem = [];

			if (action.payload.piimri.length > 0) {
				PIItem.push({
					type: "PICreate",
					// piitem: PIitem.piitem,
				});
			}

			state = {
				...state,
				loading: false,
				itemTimeLine: [mrItemCreate, ...MRitemTimeLine],
				mrIssueItem: [mrIssueItemCreate, ...PIItem],
				PITimeLineItems: action.payload.piimri,
				TimeLineProduct: action.payload.product,
			};
			break;

		case PI_ITEM_TIME_LINE:
			var PIItemCreate = {
				type: "PIICreate",
				createdon:
					action.payload.PIItem.piitem.purchaseindent.createdon,
				createdby:
					action.payload.PIItem.piitem.purchaseindent.createdby,
				product: state.TimeLineProduct,
				qty: action.payload.PIItem.piitem.qty,
				unit: action.payload.PIItem.piitem.unit,
			};
			var PIitemTimeLine = action.payload.PIItem.piitem.pii_approvals.map(
				(item) => {
					return {
						...item,
						type: "PIIApproval",
						product: state.TimeLineProduct,
					};
				}
			);
			var PITimeLine =
				action.payload.PIItem.piitem.purchaseindent.pi_approvals.map(
					(PI) => {
						return {
							...PI,
							type: "PIApproval",
							purchaseindent_code:
								action.payload.PIItem.piitem.purchaseindent
									.code,
							product: state.TimeLineProduct,
						};
					}
				);
			var RFQItems = {};
			var CQItem = [];
			if (action.payload.PIItem.piitem.rfqipii.length > 0) {
				var rfqdata = action.payload.PIItem.piitem.rfqipii[0];
				RFQItems = {
					type: "RFQICreate",
					createdon: rfqdata.rfqitem.requestforquotation.createdon,
					createdby: rfqdata.rfqitem.requestforquotation.createdby,
					product: state.TimeLineProduct,
					qty: rfqdata.rfqitem.qty,
					unit: rfqdata.rfqitem.unit,
					RFQ_code: rfqdata.rfqitem.requestforquotation.code,
				};

				if (rfqdata.rfqitem.cqitem.length > 0) {
					CQItem.push({
						type: "CQCreate",
						// piitem: PIitem.piitem,
					});
				}
				state.CQTimeLineItems = rfqdata.rfqitem.cqitem;
			}

			state = {
				...state,
				loading: false,
				POItemsTimeLine: [],
				selectedPIItemId: action.payload.PIItem.id,
				PIitemTimeLine: [
					PIItemCreate,
					...PIitemTimeLine,
					...PITimeLine,
				],
				RFQItemsTimeLine: [RFQItems, ...CQItem],
			};
			break;

		case PO_ITEM_TIME_LINE:
			var POItemCreate = {
				type: "POICreate",
				createdon: action.payload.POItem.poitem[0].createdon,
				createdby:
					action.payload.POItem.poitem[0].purchaseorder.createdby,
				product: state.TimeLineProduct,
				qty: action.payload.POItem.poitem[0].qty,
				unit: action.payload.POItem.poitem[0].unit,
				price: action.payload.POItem.poitem[0].price,
				gross: action.payload.POItem.poitem[0].gross,
				purchaseorder_code:
					action.payload.POItem.poitem[0].purchaseorder.code,
			};
			// var RFQItemCreate = action.payload.rfqipii.map((RFQitem) => {
			//   return { ...RFQitem.rfqitem, type: "RFQCreate" };
			// });
			// console.log("action.payload.POItem", action.payload.POItem);
			var IGPItems = [];
			if (action.payload.POItem.poitem[0].grn2items.length > 0) {
				IGPItems.push({
					type: "IGPCreate",
				});
			}
			state.IGPTimeLine = action.payload.POItem.poitem[0].grn2items;

			state = {
				...state,
				selectedCQItemId: action.payload.POItem.id,
				loading: false,
				POItemsTimeLine: [POItemCreate, ...IGPItems],
			};
			break;
		case IGP_ITEM_TIME_LINE:
			// console.log("IGP_ITEM_TIME_LINE", action.payload.IGPItem);
			var IGPItemCreate = {
				type: "IGPICreate",
				createdon: action.payload.IGPItem.goodsreceivednote2_createdon,
				// createdby: action.payload.POItem.poitem[0].purchaseorder.createdby,
				personname:
					action.payload.IGPItem.goodsreceivednote2_personname,
				vehicleno: action.payload.IGPItem.goodsreceivednote2_vehicleno,
				igpcode: action.payload.IGPItem.goodsreceivednote2_code,
			};

			state = {
				...state,
				selectedIGPItemId: action.payload.IGPItem.id,
				loading: false,
				IGPItemsTimeLine: [IGPItemCreate],
			};
			break;

		case PRODUCT_STORE_QTY:
			state = {
				...state,
				loading: false,
			};
			break;
		case PRODUCT_STORE_QTY_SUCCESSFUL:
			state = {
				...state,
				loading: false,
				productStoreQty: action.payload,
			};
			break;
		case PDF_DOWNNLOAD:
			state = {
				...state,
				loading: false,
			};
			break;
		case PRODUCT_HISTORY:
			state = {
				...state,
				loading: true,
			};
			break;

		case PRODUCT_HISTORY_SUCCESSFUL:
			state = {
				...state,
				productHistorylist: action.payload.results,
				loading: false,
				productHistory_model: true,
				// model: true,
			};
			break;
		case PRODUCT_HISTORY_MODEL_CLOSE:
			state = {
				...state,
				loading: false,
				productHistory_model: false,
			};
			break;
		case PRODUCT_ITEM_HISTORY_MODEL_OPEN:
			state = {
				...state,
				productItemLoglist: action.payload.data,
				loading: false,
				productItemHistory_model: true,
				// model: true,
			};
			break;
		case PRODUCT_ITEM_HISTORY_MODEL_CLOSE:
			state = {
				...state,
				loading: false,
				productItemHistory_model: false,
			};
			break;
		case MR_ITEM_IMAGES_UPLOAD:
			state = {
				...state,
				loading: false,
				MRItemImage: [
					...state.MRItemImage,
					{
						Product_id: action.payload.ProductId,
						ItemImages: action.payload.mrItemImage,
					},
				],
			};
			break;
		case MR_ITEM_UPDATE_IMAGE:
			state = {
				...state,
				loading: false,
			};
			break;
		case API_ERROR:
			state = {
				...state,
				loading: false,
				error_msg: action.payload,
			};
			break;
		case MATERIAL_REQUEST_CLOSE:
			state = {
				...state,
				loading: false,
			};
			break;
		case MRQ_FOCUS_POST:
			state = {
				...state,
				loading: false,
			};
			break;
		default:
			state = { ...state };
			break;
	}
	return state;
};
export default materialrequest;
